import { Task, AnswerStateEnum, Player } from '../types/commonTypes'

export const getCompletedAndEvaluatedCounts = (
  players: Player[],
  task: Task,
): { completedCount: number; evaluatedCount: number } => {
  let completedCount = 0
  let evaluatedCount = 0
  players
    .filter((p) => !p.deleted)
    .forEach((player) => {
      if (
        task.subtasks.every(
          (subtask) =>
            (
              subtask.answers?.filter(
                (a) => a.userId === player.id && [AnswerStateEnum.GRADED, AnswerStateEnum.READY].includes(a.state),
              ) || []
            ).length > 0,
        )
      )
        completedCount++
      if (
        task.subtasks.every(
          (subtask) =>
            (subtask.answers?.filter((a) => a.userId === player.id && [AnswerStateEnum.GRADED].includes(a.state)) || [])
              .length > 0,
        )
      )
        evaluatedCount++
    })
  return { completedCount, evaluatedCount }
}

export const getLastActionTime = (task: Task): string => {
  const lastAnswerByTime =
    task.subtasks[0].answers && task.subtasks[0].answers[0]
      ? task.subtasks[0].answers?.sort((a, b) =>
          (a.completedAt || a.openedAt) < (b.completedAt || b.openedAt) ? -1 : 1,
        )[task.subtasks[0].answers.length - 1]
      : null
  return lastAnswerByTime ? lastAnswerByTime.completedAt || lastAnswerByTime.openedAt : '00:00:00'
}

export const getSumCompletionTime = (task: Task): number => {
  let sumCompletionTime = 0
  try {
    sumCompletionTime =
      task.subtasks[0].answers
        ?.map((a) => {
          if (a.completedAt && a.openedAt) return new Date(a.completedAt).getTime() - new Date(a.openedAt).getTime()
          else return 0
        })
        .reduce((acc, curr) => {
          return acc + curr
        }, 0) ?? 0
  } catch (e) {}
  return sumCompletionTime
}
